module.exports = "/_next/static/images/Hero@2x-cc6d00d2b919854254d05a3c0814239e.webp";